const e = {
  name: "Close",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M34.3,40L20,25.7L5.7,40L0,34.3L14.3,20L0,5.7L5.7,0L20,14.3L34.3,0L40,5.7L25.7,20L40,34.3L34.3,40z
			 M20,22.8l14.3,14.3l2.8-2.8L22.8,20L37.2,5.7l-2.8-2.8L20,17.2L5.7,2.8L2.8,5.7L17.2,20L2.8,34.3l2.8,2.8L20,22.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Close
};
